module.exports = __webpack_public_path__ + "img/bosnia-and-herzegovina.c96fe7bf.svg";